import React, { useCallback, useEffect } from 'react';
import { checkUpdatedBundleVersion } from '../../services/detect_app_update';

const AppUpdateControl = () => {
  const cancelAppUpdateControl = () => {
    if (window._gAppUpdateInterval) {
      console.log('Clearing interval for app update control');
      clearInterval(window._gAppUpdateInterval);
      window._gAppUpdateInterval = null;
    }
  };

  const appUpdateControlLoop = useCallback(() => {
    if (!window._gAppUpdateInterval) {
      console.log(`Setting interval for app update control`);
      window._gAppUpdateInterval = setInterval(async () => {
        const remoteBundleVersion = await checkUpdatedBundleVersion();
        console.log(
          `Checking for app update, remote bundle version: ${remoteBundleVersion}`,
        );
      }, 3 * 60 * 1000);
    }
  }, []);

  useEffect(() => {
    appUpdateControlLoop();
    return () => {
      cancelAppUpdateControl();
    };
  }, [appUpdateControlLoop]);

  return null;
};

export default AppUpdateControl;
